import { apiClient } from "services/api/client";

export const updateAppText = async (command: { id: string; text: string }) => {
  const url = "administrator/appText";
  const response = await apiClient.put(url, command);
  return response.data;
};
